const items1 = ["MIRE MEDIA","AI-POWERED","SHORT DRAMA","MALAYSIA #1","500K+ USERS","RM 16M+","NEXT GENERATION","东南亚短剧平台","KUALA LUMPUR","SEA EXPANSION","IP DEVELOPMENT","7–14 DAY CYCLE",];
const items2 = ["MIRE DRAMA","AI PRODUCTION","LOCALIZED CONTENT","MULTI-PLATFORM","PARTNERSHIP","ADVERTISING","IP LICENSING","DISTRIBUTION","INDONESIA","GLOBAL REACH","LIONS CLUB","ALOHA IP",];

const sep = <span style={{color:"#FF1C35",margin:"0 18px",opacity:0.7}}>◆</span>;

const Ticker = () => (
  <div style={{ width:"100%",overflow:"hidden",background:"rgba(255,28,53,0.04)",borderTop:"1px solid rgba(255,28,53,0.15)",borderBottom:"1px solid rgba(255,28,53,0.15)",padding:"12px 0",position:"relative",zIndex:20 }}>
    <style>{`
      @keyframes tickLeft{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}
      @keyframes tickRight{0%{transform:translateX(-50%)}100%{transform:translateX(0)}}
      .tick-row{display:flex;white-space:nowrap;font-weight:700;font-size:12px;letter-spacing:2.5px}
      .tick-row1{animation:tickLeft 30s linear infinite;color:rgba(255,255,255,0.55)}
      .tick-row2{animation:tickRight 36s linear infinite;color:rgba(255,28,53,0.7);margin-top:8px;font-size:11px;letter-spacing:3px}
      .tick-row:hover{animation-play-state:paused}
    `}</style>
    <div className="tick-row tick-row1">
      {[...items1,...items1].map((t,i)=><span key={i}>{t}{sep}</span>)}
    </div>
    <div className="tick-row tick-row2">
      {[...items2,...items2].map((t,i)=><span key={i}>{t}{sep}</span>)}
    </div>
    <div style={{position:"absolute",top:0,left:0,bottom:0,width:80,background:"linear-gradient(to right,#080808,transparent)",pointerEvents:"none",zIndex:1}}/>
    <div style={{position:"absolute",top:0,right:0,bottom:0,width:80,background:"linear-gradient(to left,#080808,transparent)",pointerEvents:"none",zIndex:1}}/>
  </div>
);
export default Ticker;
